import {
  isUspsCat,
  isUspsProd,
} from '@mgo/core/src/environment';

const enableSplunkTracking = () => {
  const origin = window.location.href;
  let deploymentEnvironment = '';
  let rumAccessToken = '';
  let applicationName = '';
  if (isUspsProd(origin)) {
    applicationName = '6432_MGCOM_RUM_PROD';
    rumAccessToken = 'UW_oiqFr_7QUWf4Z6Wfwdg';
    deploymentEnvironment = 'PROD';
  } else if (isUspsCat(origin)) {
    applicationName = '6432_MGCOM_RUM_CAT';
    rumAccessToken = 'z1cnfH2yJV_xZeqx2SfhQA';
    deploymentEnvironment = 'CAT';
  }
  if (!deploymentEnvironment) {
    window.console.log('Splunk observability tracking is only enabled in CAT and PROD environments.');
    return;
  }
  if (window.SplunkRum) {
    window.SplunkRum.init({
      applicationName,
      realm: 'us1',
      rumAccessToken,
      deploymentEnvironment,
    });
  } else {
    window.console.error('SplunkRum script not loaded. Unable to initialize Splunk tracking.');
  }
  if (window.SplunkSessionRecorder) {
    window.SplunkSessionRecorder.init({
      app: applicationName,
      realm: 'us1',
      rumAccessToken,
    });
  } else {
    window.console.error('SplunkSessionRecorder script not loaded. Unable to initialize Splunk tracking.');
  }
};
export default enableSplunkTracking;
